import type { TicketPart } from '@/types/parentTicket'

function toTaskId(value: unknown): number | null {
  if (value == null || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

/** Resolve linked task IDs from API shape (scalar or pivot array). */
export function getPartTaskIds(part: TicketPart): number[] {
  const fromArray = part.task_ids?.length
    ? part.task_ids
    : part.taskIds?.length
      ? part.taskIds
      : null

  if (fromArray?.length) {
    return fromArray.map(toTaskId).filter((id): id is number => id != null)
  }

  const scalar = toTaskId(part.child_ticket_id ?? part.childTicketId)
  return scalar != null ? [scalar] : []
}

export function isPartLinkedToTask(part: TicketPart): boolean {
  return Boolean(part.added_as_task || part.addedAsTask || getPartTaskIds(part).length > 0)
}

export function partIsLinkedToTask(part: TicketPart, taskId: number | null | undefined): boolean {
  const normalizedTaskId = toTaskId(taskId)
  if (normalizedTaskId == null) return false
  return getPartTaskIds(part).includes(normalizedTaskId)
}

export function getPartPrimaryTaskId(part: TicketPart): number | null {
  const ids = getPartTaskIds(part)
  return ids[0] ?? null
}

export function getPartTaskNumber(part: TicketPart, taskId: number): string | null {
  const normalizedTaskId = toTaskId(taskId)
  if (normalizedTaskId == null) return null
  const match = part.tasks?.find((t) => toTaskId(t.id) === normalizedTaskId)
  return match?.task_number ?? null
}
